export const avatar = require('./avatar.svg');
export const avatarLoggedIn = require('./avatarLoggedIn.svg');
export const heart = require('./heart.svg');
export const search = require('./search.svg');
export const close = require('./close.svg');
export const burger = require('./burger.svg')
export const arrow = require('./arrow.svg')
export const shoppingBag = require('./orders.svg')